import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


@Component({
    selector: 'app-rating-star',
    templateUrl: './rating-star.html'
})
export class RatingStarComponent implements OnInit {
    @Input('starValue') starValue: number = 0;
    @Input('numberStar') numberStar: number = 5;
    @Input('halfStar') halfStar: boolean = false;

    @Output('changeRate') changeRate: EventEmitter<number> = new EventEmitter<number>();


    public half = false;
    public arrayStar = [];

    constructor() {

    }

    ngOnInit(): void {
        this.starValue = Math.round(this.starValue)
        this.arrayStar = this.genArray(this.numberStar);
    }

    public genArray(i) {
        let k = this.halfStar ? 0.5 : 1;
        return i ? this.genArray(i - k).concat(i) : []
    }
    
    changeRateEvent(value: number) {
        this.changeRate.emit(value);
    }
}
